import axios from "axios";

function getHeaders() {
  return {
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${localStorage.getItem("token")}`,
    },
  };
}

export const createCoreService = async (core_service_name) => {
  try {
    const response = await axios.post(
      `${process.env.REACT_APP_BASE_URL}/invoice_price/api/core-services/`,
      { core_service_name },
      getHeaders()
    );
    return response.data;
  } catch (error) {
    if (error.response) {
      // Server returned an error
      return { error: error.response.data.error };
    } else if (error.request) {
      // Request was made but no response was received
      return { error: "No response from server." };
    } else {
      // Something else happened
      return { error: error.message };
    }
  }
};

// Service to handle dropping dynamic tables
export const dropTable = async (coreServiceName) => {
  try {
    const response = await axios.delete(
      `${process.env.REACT_APP_BASE_URL}/invoice_price/api/table/drop/${coreServiceName}/` // Correct string interpolation
    );

    return response.data;
  } catch (error) {
    console.error("Error dropping table:", error);
    throw error;
  }
};

// Service to handle renaming a table
export const renameTable = async (oldName, newName) => {
  try {
    const response = await axios.patch(
      `${process.env.REACT_APP_BASE_URL}/invoice_price/api/table/rename/`,
      {
        old_table_name: oldName,
        new_table_name: newName,
      }
    );
    return response.data;
  } catch (error) {
    console.error("Error renaming table:", error);
    throw error;
  }
};
// Get List of Abroad Counseling Services
export const getNewTable = async (data) => {
  const response = await axios.get(
    `${process.env.REACT_APP_BASE_URL}/invoice_price/api/core-services/`,
    getHeaders()
  );
  // const serviceNames = response.data.map(
  //   (service) => service.core_service_name
  // );
  // return serviceNames;
  return response.data;
};

// Get List of Abroad Counseling Services
export const getTableData = async (coreServiceName) => {
  const response = await axios.get(
    `${process.env.REACT_APP_BASE_URL}/invoice_price/api/table/select/${coreServiceName}/`,
    getHeaders()
  );
  return response.data;
};
